import React, { } from "react";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";

const Modal = ({ title, onClose, onYes, isInput, iconName, bodyText, colorType, remarks, handleInputChange, errorMsg }) => {
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <FontAwesomeIcon icon={faXmark} onClick={onClose} size="lg" cursor="pointer" />
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.textContainer}>
                        <FontAwesomeIcon icon={iconName} size="3x" color={colorType} />
                        <h2 className={styles.title}>{title}</h2>
                        {isInput ?
                            <div className={`input-group ${styles.modalInutGroup}`}>
                                <div className={styles.labelDiv}>
                                    <label className={`form-label ${styles.modalLabel}`}>Remarks</label>
                                </div>
                                <textarea
                                    type="textarea"
                                    rows="2"
                                    placeholder="Reject Reason"
                                    value={remarks}
                                    onChange={handleInputChange}
                                    className={`${styles.formInput} primary-input`}
                                />
                                {errorMsg && <p className={`${styles.errorMsg} error-response`}>{errorMsg}</p>}
                            </div>
                            :
                            <p className={styles.modalText}>{bodyText}</p>}
                    </div>
                    <div className={styles.buttonContainer}>
                        <button onClick={onYes} className={`${styles.modalBtn} ${styles.yesButton}`} type="button">Yes</button>
                        <button onClick={onClose} className={`${styles.modalBtn} ${styles.noButton}`} type="button">No</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;